import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import ConnectedModal from 'containers/ConnectedModal';
import useConnectedModal from 'containers/ConnectedModal/useConnectedModal';
import useGetProjectConfig from 'hooks/useGetProjectConfig';
import { clearCreateCreationAsset } from 'redux/modules/wizard-export/actions';
import EditTemplateModalContents from './EditTemplateModalContents';
import { block } from './utils';

export interface EditTemplateModalProps {}

const EditTemplateModal: React.FC<EditTemplateModalProps> = () => {
  const { show, params } = useConnectedModal('EditTemplate');
  const {
    projectId,
    widgetId,
    features,
    isShortFormProject,
    embedConfig: embedConfigProp,
  } = params ?? {};

  const { embedConfig, fetchProjectConfig, reset } = useGetProjectConfig({
    projectId,
    widgetId,
  });

  const dispatch = useDispatch();

  useEffect(() => {
    if (!show || !projectId || !widgetId || embedConfigProp) {
      return undefined;
    }

    fetchProjectConfig();

    return () => reset();
  }, [embedConfigProp, fetchProjectConfig, projectId, reset, show, widgetId]);

  return (
    <ConnectedModal
      name="EditTemplate"
      isFullScreen
      backdropClassName={block('backdrop')}
      onExited={() => dispatch(clearCreateCreationAsset())}
    >
      <EditTemplateModalContents
        {...{ projectId, features, isShortFormProject }}
        embedConfig={embedConfigProp ?? embedConfig}
      />
    </ConnectedModal>
  );
};

export default EditTemplateModal;
